import React from 'react';
import { cn } from '../../lib/utils';

export function AnimatedShinyText({
  children,
  className,
  shimmerWidth = 100,
}) {
  return (
    <span
      style={{
        '--shimmer-width': `${shimmerWidth}px`,
      }}
      className={cn(
        'mx-auto max-w-md text-slate-700 dark:text-slate-200/80 font-medium bg-clip-text',
        'animate-shiny-text bg-[linear-gradient(110deg,currentColor_45%,rgba(250,204,21,0.8)_55%,currentColor_65%)] bg-[length:var(--shimmer-width)_100%]',
        className
      )}
    >
      {children}
    </span>
  );
}
